import { cn } from '@/lib/utils'
import { Typography } from '@/components/ui/typography'
import { Command } from 'lucide-react'

// User-Agent Client Hints (`userAgentData`) are not in TypeScript's DOM lib yet.
type NavigatorWithUserAgentData = Navigator & {
  userAgentData?: { platform?: string }
}

function getNavigatorPlatform(nav: NavigatorWithUserAgentData) {
  return nav.userAgentData?.platform || nav.platform
}

export type ModifierKeyProps = {
  className?: string
}

const ModifierKey = ({ className, ...props }: ModifierKeyProps) => {
  const os = typeof navigator === 'undefined' ? '' : getNavigatorPlatform(navigator)?.toLowerCase()

  return os?.startsWith('mac') ? (
    <Command className={cn('inline h-3 w-3', className)} {...props} />
  ) : (
    <Typography as="span" variant="label" tone="inherit" className={className} {...props}>
      Ctrl
    </Typography>
  )
}

export default ModifierKey
